import API from 'services/TAPS_API';

export default function overdueSend(cardId, type) {
  return API.request({
    method: 'GET',
    url: `/notification/1151020/${cardId}/notify-of-alerts`,
    params: type ? type : null,
  });
}
